import { motion } from 'framer-motion';
import BlurFade from '../ui/BlurFade';
import { profile } from '../../data/profile';

const Hero = () => {
  return (
    <section id="hero" className="bg-white pb-16 pt-32 text-black">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-10 px-6 sm:flex-row sm:justify-between">
        <div>
          <BlurFade delay={0.05}>
            <h1 className="text-4xl font-black leading-tight tracking-tight sm:text-5xl">
              Hi, I'm <span className="underline decoration-4">{profile.name.split(' ')[0]}</span>
            </h1>
          </BlurFade>
          <BlurFade delay={0.15}>
            <h2 className="mt-1 text-4xl font-black leading-tight tracking-tight sm:text-5xl">
              {profile.title}
            </h2>
          </BlurFade>
          <BlurFade delay={0.25}>
            <p className="mt-5 max-w-md text-black/60">{profile.bio[0]}</p>
          </BlurFade>
          <BlurFade delay={0.35}>
            <p className="mt-4 inline-block rounded-full border-2 border-black px-4 py-1.5 text-sm font-semibold">
              {profile.status}
            </p>
          </BlurFade>
        </div>

        <BlurFade delay={0.2} className="w-56 shrink-0 sm:w-72">
          <motion.img
            src="/images/hero.png"
            alt={`${profile.name} illustration`}
            animate={{ y: [0, -12, 0] }}
            transition={{ repeat: Infinity, duration: 4, ease: 'easeInOut' }}
            className="w-full"
          />
        </BlurFade>
      </div>
    </section>
  );
};

export default Hero;
